<div class="divide-y divide-slate-200/80 dark:divide-white/10">

  <form [formGroup]="form" (ngSubmit)="save()">

    <!-- Tipo di Profilo -->
    <section class="grid grid-cols-1 gap-x-8 gap-y-10 py-12 md:grid-cols-3">
      <div>
        <h2 class="text-base font-semibold leading-7 text-gray-900 dark:text-white">Tipo di Profilo</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600 dark:text-gray-400">Seleziona se i documenti fiscali devono essere intestati a te o alla tua azienda.</p>
      </div>

      <div class="md:col-span-2">
        <div class="flex items-center gap-1.5 p-1 bg-slate-100 dark:bg-white/5 rounded-2xl w-fit border border-slate-200/80 dark:border-white/10 shadow-sm shadow-slate-900/5">
          <button type="button"
                  (click)="form.get('isCompany')?.setValue(false)"
                  [class]="!form.get('isCompany')?.value ? 'bg-white dark:bg-gray-800 shadow-sm shadow-slate-900/5 text-indigo-600 dark:text-indigo-400 font-extrabold' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 font-bold'"
                  class="px-6 py-2 text-sm rounded-xl transition-all cursor-pointer">
            Privato
          </button>
          <button type="button"
                  (click)="form.get('isCompany')?.setValue(true)"
                  [class]="form.get('isCompany')?.value ? 'bg-white dark:bg-gray-800 shadow-sm shadow-slate-900/5 text-indigo-600 dark:text-indigo-400 font-extrabold' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 font-bold'"
                  class="px-6 py-2 text-sm rounded-xl transition-all cursor-pointer">
            Azienda
          </button>
        </div>
      </div>
    </section>

    <!-- Dati Intestazione -->
    <section class="grid grid-cols-1 gap-x-8 gap-y-10 py-12 md:grid-cols-3">
      <div>
        <h2 class="text-base font-semibold leading-7 text-gray-900 dark:text-white">Dati Intestazione</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600 dark:text-gray-400">Questi dati appariranno in fattura.</p>
      </div>

      <div class="md:col-span-2 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

        @if (!form.get('isCompany')?.value) {
          <div class="sm:col-span-3">
            <label class="block text-sm font-medium text-gray-900 dark:text-white">Nome</label>
            <input type="text" formControlName="name" class="dm-input">
          </div>
          <div class="sm:col-span-3">
            <label class="block text-sm font-medium text-gray-900 dark:text-white">Cognome</label>
            <input type="text" formControlName="surname" class="dm-input">
          </div>
        } @else {
          <div class="sm:col-span-6">
            <label class="block text-sm font-medium text-gray-900 dark:text-white">Ragione Sociale</label>
            <input type="text" formControlName="companyName" class="dm-input">
          </div>
        }

        <div class="sm:col-span-3">
          <label class="block text-sm font-medium text-gray-900 dark:text-white">Codice Fiscale</label>
          <input type="text" formControlName="taxCode" class="dm-input">
        </div>

        @if (form.get('isCompany')?.value) {
          <div class="sm:col-span-3">
            <label class="block text-sm font-medium text-gray-900 dark:text-white">Partita IVA</label>
            <input type="text" formControlName="vatNumber" class="dm-input">
          </div>
        }
      </div>
    </section>

    <!-- Sede Legale / Residenza -->
    <section class="grid grid-cols-1 gap-x-8 gap-y-10 py-12 md:grid-cols-3">
      <div>
        <h2 class="text-base font-semibold leading-7 text-gray-900 dark:text-white">Sede Legale / Residenza</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600 dark:text-gray-400">L'indirizzo di fatturazione ufficiale.</p>
      </div>

      <div class="md:col-span-2 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
        <div class="sm:col-span-4">
          <label class="block text-sm font-medium text-gray-900 dark:text-white">Indirizzo</label>
          <input type="text" formControlName="address" class="dm-input">
        </div>
        <div class="sm:col-span-2">
          <label class="block text-sm font-medium text-gray-900 dark:text-white">Civico</label>
          <input type="text" formControlName="houseNumber" class="dm-input">
        </div>
        <div class="sm:col-span-2">
          <label class="block text-sm font-medium text-gray-900 dark:text-white">CAP</label>
          <input type="text" formControlName="zipCode" class="dm-input">
        </div>
        <div class="sm:col-span-3">
          <label class="block text-sm font-medium text-gray-900 dark:text-white">Città</label>
          <input type="text" formControlName="city" class="dm-input">
        </div>
        <div class="sm:col-span-1">
          <label class="block text-sm font-medium text-gray-900 dark:text-white">Prov.</label>
          <input type="text" formControlName="province" class="dm-input" maxlength="2">
        </div>
      </div>
    </section>

    <!-- Recapiti Digitali (Mostrati solo per le Aziende) -->
    @if (form.get('isCompany')?.value) {
      <section class="grid grid-cols-1 gap-x-8 gap-y-10 py-12 md:grid-cols-3">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900 dark:text-white">Recapiti Digitali</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600 dark:text-gray-400">Inserisci il Codice SDI oppure l'indirizzo PEC per la fattura elettronica.</p>
        </div>

        <div class="md:col-span-2 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div class="sm:col-span-4">
            <label class="block text-sm font-medium text-gray-900 dark:text-white">PEC (Indirizzo Digitale)</label>
            <input type="email" formControlName="pecAddress" class="dm-input" placeholder="opzionale se inserisci il codice SDI">
          </div>

          <div class="sm:col-span-2">
            <label class="block text-sm font-medium text-gray-900 dark:text-white">Codice SDI</label>
            <input type="text" formControlName="sdiCode" class="dm-input" placeholder="7 caratteri">
          </div>
        </div>
      </section>
    }

    <!-- Submit -->
    <div class="py-6 flex justify-end border-t border-slate-200/80 dark:border-white/10">
      <button type="submit"
              [disabled]="form.invalid || loading || form.pristine"
              class="cursor-pointer rounded-md bg-indigo-600 px-10 py-2.5 text-sm font-bold text-white shadow-sm shadow-slate-900/5
              hover:bg-indigo-500 disabled:opacity-50 transition-all disabled:cursor-default disabled:hover:bg-indigo-600">
        {{ !!taxInformation ? 'Aggiorna dati' : 'Salva informazioni' }}
      </button>
    </div>
  </form>
</div>

<dm-loading [active]="loading"></dm-loading>
